import { Link } from 'react-scroll';

const HeroSection = () => (
  <section
    id="hero"
    className="relative min-h-screen flex items-center justify-center overflow-hidden"
  >
    {/* Background Image */}
    <div
      className="absolute inset-0 bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage:
          "url('https://public.readdy.ai/ai/img_res/b42a97c8706654502b4da3a215cb244a.jpg')",
      }}
    />
    {/* Overlay */}
    <div className="absolute inset-0 bg-gradient-to-br from-black/75 via-black/60 to-black/70" />

    <div className="relative z-10 w-full max-w-5xl mx-auto px-6 md:px-10 text-center py-32 md:py-40">
      {/* Badge */}
      <div className="inline-flex items-center gap-2 bg-orange-500/20 border border-orange-500/40 text-orange-400 text-xs font-semibold uppercase tracking-widest px-4 py-2 rounded-full mb-8">
        <span className="w-2 h-2 rounded-full bg-orange-400 animate-pulse inline-block" />
        Google Ads &amp; Landing Page Specialists
      </div>

      <h1 className="text-4xl md:text-6xl lg:text-7xl font-extrabold text-white leading-tight mb-6">
        Get More Customers for<br />
        <span className="text-orange-400">Your Business</span> — Consistently
      </h1>

      <p className="text-lg md:text-xl text-white/80 max-w-2xl mx-auto mb-10 leading-relaxed">
        We help local businesses show up at the top of Google and turn searches into real calls, leads, and paying customers.
      </p>

      <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-10">
        <Link
          to="offer"
          smooth
          duration={500}
          offset={-80}
          className="whitespace-nowrap cursor-pointer w-full sm:w-auto px-8 py-4 bg-orange-500 hover:bg-orange-600 text-white font-bold text-base rounded-lg transition-all"
        >
          Get More Customers
        </Link>
        <Link
          to="form"
          smooth
          duration={500}
          offset={-80}
          className="whitespace-nowrap cursor-pointer w-full sm:w-auto px-8 py-4 bg-white/10 hover:bg-white/20 border-2 border-white/50 text-white font-bold text-base rounded-lg transition-all backdrop-blur-sm"
        >
          Book a Strategy Call
        </Link>
      </div>

      <p className="text-white/50 text-sm italic tracking-wide">
        No contracts. No fluff. Just results.
      </p>
    </div>

    {/* Scroll indicator */}
    <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-1 text-white/40 animate-bounce">
      <i className="ri-arrow-down-line text-xl" />
    </div>
  </section>
);

export default HeroSection;
